import { Injectable } from '@angular/core';
import { IntegrationsService } from './integration.service';
import { IntegrationModel, IntegrationPlatformType } from './models/integration.model';
import { interval, Observable } from 'rxjs';
import { distinctUntilKeyChanged, flatMap, takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IntegrationStatePollingService {
  private POLLING_INTERVAL_MILLIS = 1000 * 3;
  private pollingActive = false;

  constructor(private integrationService: IntegrationsService) {}

  public pollIntegrationState(type: IntegrationPlatformType): Observable<IntegrationModel> {
    this.pollingActive = true;

    return interval(this.POLLING_INTERVAL_MILLIS).pipe(
      takeWhile(() => this.pollingActive),
      flatMap(() => this.integrationService.checkIntegrationStatus(type)),
      distinctUntilKeyChanged('integrated')
    );
  }

  public stopPolling() {
    this.pollingActive = false;
  }
}
